import {Option} from 'platform/components';

import {useListTeamsQuery} from '@dms/api/customer';
import {useBranches, useCodeList, useVehicleCatalogue} from '@dms/shared';

export interface AssignmentConditionFormOptionsResult {
  teamOptions: Option[];
  branchOptions: Option[];
  leadSourceOptions: Option[];
  vehicleTypeOptions: Option[];
  vehicleConditionOptions: Option[];
  isLoading: boolean;
}

export function useAssignmentConditionFormOptions(): AssignmentConditionFormOptionsResult {
  const {branchOptions, isLoading: isBranchesLoading} = useBranches();
  const [leadSourceCodes, {isLoading: isLeadSourceLoading}] = useCodeList('interest_source');
  const [vehicleCatalogue, {isLoading: isVehicleCatalogueLoading}] = useVehicleCatalogue(undefined);
  const {data: teams, isLoading: isTeamsLoading} = useListTeamsQuery({});

  const teamOptions: Option[] = teams?.map((team) => ({value: team.id, label: team.name})) ?? [];

  const leadSourceOptions: Option[] =
    leadSourceCodes?.map((code) => ({
      value: code.codeId,
      label: code.name,
    })) ?? [];

  const vehicleTypeOptions: Option[] =
    vehicleCatalogue?.vehicleTypeOptions?.map((opt) => ({
      value: opt.value,
      label: opt.label,
    })) ?? [];
  const vehicleConditionOptions: Option[] =
    vehicleCatalogue?.vehicleConditionOptions?.map((opt) => ({
      value: opt.value,
      label: opt.label,
    })) ?? [];

  const isLoading =
    isBranchesLoading || isLeadSourceLoading || isTeamsLoading || isVehicleCatalogueLoading;

  const normalizedBranchOptions: Option[] = branchOptions
    .filter((opt): opt is Option => opt.label != null && opt.label !== '')
    .map((opt) => ({value: opt.value, label: opt.label}));

  return {
    teamOptions,
    branchOptions: normalizedBranchOptions,
    leadSourceOptions,
    vehicleTypeOptions,
    vehicleConditionOptions,
    isLoading,
  };
}
